<div class="container-fluid px-0 h-100 overflow-hidden">
    <div class="custom-randomization-wrapper row">
        <div class="col-2 h-100 p-0">
            <app-randomization-sidebar
                [trainingId]="trainingId"
            ></app-randomization-sidebar>
        </div>
        <div class="col-10 p-0">
            <div class="code-container">
                <textarea
                    [(ngModel)]="customCode"
                    (keydown)="handleKeydown($event)"
                    spellcheck="false"
                    autocapitalize="off"
                    autocomplete="off"
                    [disabled]="editingIsDisabled"
                ></textarea>
                <div
                    class="
                        save-button-container
                        d-flex
                        justify-content-end
                        mx-3
                    "
                >
                    <button
                        class="btn btn-tryb-blue"
                        (click)="onSaveCode()"
                        [disabled]="editingIsDisabled"
                    >
                        {{
                            'neuralNetwork.codeEditor.customRandomization.save'
                                | translate
                        }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
